export const notificationsData = [
  {
    notificationIcon: `https://randomuser.me/api/portraits/men/${Math.floor(Math.random() * 100)}.jpg`,
    notificationId: 1,
    name: "John Smith",
    action: "Added a new account",
    date: "2022-03-15",
    itemType: "Account",
  },
  {
    notificationIcon: `https://randomuser.me/api/portraits/women/${Math.floor(Math.random() * 100)}.jpg`,
    notificationId: 2,
    name: "Jane Doe",
    action: "Deleted an account",
    date: "2022-03-16",
    itemType: "Account",
  },
  {
    notificationIcon: `https://randomuser.me/api/portraits/men/${Math.floor(Math.random() * 100)}.jpg`,
    notificationId: 3,
    name: "Bob Johnson",
    action: "Created a client",
    date: "2022-03-17",
    itemType: "Client",
  },
  {
    notificationIcon: `https://randomuser.me/api/portraits/women/${Math.floor(Math.random() * 100)}.jpg`,
    notificationId: 4,
    name: "Samantha Lee",
    action: "Deleted a client",
    date: "2022-03-18",
    itemType: "Client",
  },
  {
    notificationIcon: `https://randomuser.me/api/portraits/men/${Math.floor(Math.random() * 100)}.jpg`,
    notificationId: 5,
    name: "David Kim",
    action: "Set a client as active",
    date: "2022-03-19",
    itemType: "Client",
  },
];